// Azure AD App Roles Configuration
// These are App Roles defined in the Azure App Registration
// Users/Groups are assigned to these roles in the Enterprise Application
//
// How App Roles work:
// 1. Define App Roles in Azure Portal > App Registrations > Your App > App roles
// 2. Assign users/groups to roles in Azure Portal > Enterprise Applications > Your App > Users and groups
// 3. Roles appear in the token as a 'roles' claim: ["Admin", "Op"]
// 4. oauth2-proxy must be configured with: --oidc-groups-claim=roles

export const APP_ROLES = {
  ADMIN: 'Admin',
  OP: 'Op',
  VIEWER: 'Viewer',
  PUBLIC: 'Public',
} as const;

export type AppRole = (typeof APP_ROLES)[keyof typeof APP_ROLES];

/**
 * Check if a user is a DIM project member based on their Azure AD App Roles
 * @param userRoles - Array of role names from oauth2-proxy (via roles claim)
 * @returns True if user is a project member
 */
export function isProjectMember(userRoles: string[] = []): boolean {
  return userRoles.includes(APP_ROLES.ADMIN) || userRoles.includes(APP_ROLES.OP);
}

/**
 * Extract user roles from Azure AD App Roles
 * @param userRoles - Array of role names from oauth2-proxy
 * @returns Array of role names
 */
export function extractRoles(userRoles: string[] = []): string[] {
  return userRoles.filter(role => (Object.values(APP_ROLES) as string[]).includes(role));
}
